import { createContext, useContext } from 'react';

import type { Platform } from './platform';

/** Espace courant (lu une fois au démarrage) : null si l'information manque. */
export const PlatformContext = createContext<Platform | null>(null);

export function usePlatform() {
  return useContext(PlatformContext);
}

/** Espace Éditeur : seulement la gestion des cliniques et l'administration des comptes. */
export const EDITOR_GROUPS = new Set(['Éditeur', 'Administration']);
export const EDITOR_ADMIN_ITEMS = new Set(['utilisateurs', 'roles', 'audit']);

export function useIsEditorSpace() {
  return usePlatform()?.editor === true;
}
